import { FC } from 'react'

import styled from 'styled-components'

import { Expectations } from '../TiktokScheduleTrackParams/Expectations'

import { CreatorTypeParameter } from './CreatorTypeParameter'

const Container = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};
  min-width: 324px;
`

const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

export const TiktokScheduleParams: FC = () => (
  <Container>
    <SubContainer>
      <Title>Share your expectations</Title>
      <CreatorTypeParameter />
      <Expectations />
    </SubContainer>
  </Container>
)
